import { ComponentType, FC } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import {
  AppConfigContextValue,
  useAppConfig,
} from '../../context/app-config-context/app-config-context';

type AppConfigProtectedProps = {
  Component: ComponentType;
  grant: keyof AppConfigContextValue;
};

export const AppConfigProtected: FC<AppConfigProtectedProps> = ({
  Component,
  grant,
}) => {
  const appConfig = useAppConfig();
  const oktaAuthResult = useOktaAuth();
  const authState = oktaAuthResult?.authState;
  const isAuthenticated =
    authState?.isAuthenticated || !!authState?.accessToken?.accessToken;

  // First check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.ROOT} replace={true} />;
  }

  // Then check if user has the required permission
  if (appConfig?.[grant]) {
    return <Component />;
  }

  return <Navigate to={ROUTES.ROOT} replace={true} />;
};
